module.exports = __webpack_public_path__ + "static/img/chzx-top.f7792683.png";